{
	"name": "@melonjs/spine-plugin",
	"version": "2.2.1",
	"description": "melonJS Spine plugin",
	"homepage": "https://www.npmjs.com/package/@melonjs/spine-plugin",
	"type": "module",
	"keywords": [
		"2D",
		"HTML5",
		"javascript",
		"TypeScript",
		"ES6",
		"Canvas",
		"WebGL",
		"WebGL2",
		"melonjs",
		"plugin",
		"spine",
		"spine-runtimes",
		"spine-animation",
		"esotericsoftware"
	],
	"repository": {
		"type": "git",
		"url": "git+https://github.com/melonjs/melonJS.git",
		"directory": "packages/spine-plugin"
	},
	"bugs": {
		"url": "https://github.com/melonjs/melonJS/issues"
	},
	"license": "MIT",
	"author": "AltByte Pte Ltd",
	"funding": "https://github.com/sponsors/melonjs",
	"engines": {
		"node": ">=24.0.0"
	},
	"exports": {
		".": "./build/index.js"
	},
	"types": "./build/index.d.ts",
	"sideEffects": false,
	"files": [
		"build/",
		"package.json",
		"README.md",
		"LICENSE",
		"CHANGELOG.md"
	],
	"peerDependencies": {
		"melonjs": ">=18.3.0"
	},
	"dependencies": {
		"@esotericsoftware/spine-canvas": "^4.2.114",
		"@esotericsoftware/spine-core": "^4.2.114",
		"@esotericsoftware/spine-webgl": "^4.2.114"
	},
	"devDependencies": {
		"concurrently": "^9.2.1",
		"esbuild": "^0.28.0",
		"melonjs": "workspace:*",
		"tsconfig": "workspace:*",
		"tsx": "^4.21.0",
		"typescript": "^6.0.2"
	},
	"scripts": {
		"dev": "concurrently --raw \"pnpm build:watch\" \"pnpm tsc:watch\"",
		"build": "tsx scripts/build.ts && pnpm types",
		"build:watch": "tsx scripts/build.ts watch",
		"prepublishOnly": "pnpm clean && pnpm build",
		"clean": "tsx scripts/clean.ts",
		"types": "tsc --project tsconfig.build.json",
		"tsc:watch": "tsc --project tsconfig.build.json --watch --noUnusedParameters false --noUnusedLocals false --preserveWatchOutput"
	}
}
